export enum QueryType {
  Is = 'Is',
  IsNull = 'Is Null',
  IsNot = 'Is not',
  IsNotNull = 'Is not Null',
}
